import { ComponentRef, Injectable, Injector, inject } from '@angular/core';
import { NotificationsState, SphereNotification } from './+state/notifications/notification.reducer';
import { Store } from '@ngrx/store';
import { ComponentPortal } from '@angular/cdk/portal';
import { Overlay, OverlayConfig, OverlayRef } from '@angular/cdk/overlay';
import { NotificationContainerComponent } from './notification/notification-container.component';

export class NotificationContainerRef {
    constructor(private overlayRef: OverlayRef) {}

    close(): void {
        this.overlayRef.dispose();
    }
}

export class NotificationCenterRef {
    constructor(private overlayRef: OverlayRef) {}

    close(): void {
        this.overlayRef.dispose();
    }
}

@Injectable({
    providedIn: 'root'
})
export class NotificationsAlertService {
    private store = inject<Store<NotificationsState>>(Store);
    private overlay = inject(Overlay);
    private injector = inject(Injector);

    public notificationContainer!: NotificationContainerComponent;
    public notificationContainerRef!: NotificationContainerRef;

    open(notification: SphereNotification) {
        if (!this.notificationContainer) {
            const overlayRef = this.createNotificationContainerOverlay();
            this.notificationContainerRef = new NotificationContainerRef(overlayRef);
            this.notificationContainer = this.attachNotificationContainer(overlayRef, this.notificationContainerRef);
        }
    }

    attachNotificationContainer(overlayRef: OverlayRef, notificationContainerRef: NotificationContainerRef) {
        const injector = this.createInjector(notificationContainerRef);
        const containerPortal = new ComponentPortal(NotificationContainerComponent, null, injector);
        const containerRef: ComponentRef<NotificationContainerComponent> = overlayRef.attach(containerPortal);
        return containerRef.instance;
    }

    createNotificationContainerOverlay() {
        const overlayConfig = this.getNotificationContainerOverlayConfig();
        return this.overlay.create(overlayConfig);
    }

    createInjector(notificationContainerRef: NotificationContainerRef): Injector {
        return Injector.create({
            parent: this.injector,
            providers: [{ provide: NotificationContainerRef, useValue: notificationContainerRef }]
        });
    }

    getNotificationContainerOverlayConfig(): OverlayConfig {
        const positionStrategy = this.overlay.position().global().left('60px').bottom('50px');

        return new OverlayConfig({
            hasBackdrop: false,
            scrollStrategy: this.overlay.scrollStrategies.noop(),
            positionStrategy
        });
    }
}
